import React from 'react';
import { Link } from 'react-router-dom';
import { NavItem } from './NavbarData';

interface DesktopNavItemProps {
  item: NavItem;
  isActive: boolean;
  isHovered: boolean;
  isDropdownVisible: boolean;
  onNavClick: (itemId: string) => void;
  onMouseEnter: (itemId: string) => void;
  onMouseLeave: () => void;
  isCountry: boolean;
}

const DesktopNavItem: React.FC<DesktopNavItemProps> = ({
  item,
  isActive,
  isHovered,
  isDropdownVisible,
  onNavClick,
  onMouseEnter,
  onMouseLeave,
  isCountry
}) => {
  console.log(isCountry);
  // const path=normalizePath(item.to)
  if(item?.id==='downloads' || item?.id==='blogs'){
   return (  <div
      className="relative h-full flex items-center"
    >
      <Link
      replace={true}
        to={(item.id=='blogs')?"/blogs": "/downloads"}
        onClick={() => onNavClick(item.id)}
        className={`h-full flex items-center text-sm lg:text-sm xl:text-sm font-medium transition-all duration-300 relative px-2 lg:px-0 py-2 group ${
          isActive
            ? "text-white"
            : "text-white hover:text-white"
        }`}
      >
        <span className="mr-1">{item.label}</span>
        </Link></div>)
  }
  return (
    <div
      className="relative h-full flex items-center"
      onMouseEnter={() => onMouseEnter(item.id)}
      onMouseLeave={onMouseLeave}
      data-nav-id={item.id}
    >
      <Link
      replace={true}
        to={ item?.to && item.to.trim() !== ""
          ? item.to.replace(/([^:]\/)\/+/g, "$1") // ✅ clean double slashes safely
          : "#"} // fallback: no redirect if empty or invalid}
        onClick={() => onNavClick(item.id)}
        className={`h-full flex items-center text-sm lg:text-sm xl:text-sm font-medium transition-all duration-300 relative px-2 lg:px-0 py-2 group ${
          isActive
            ? "text-white"
            : "text-white hover:text-white"
        }`}
      >
        <span className="mr-1">{item.label}</span>

        {/* If it's a country, show right arrow, otherwise dropdown arrow */}
        {(item?.children)? (
          <svg
            className={`w-3 h-3 lg:w-4 lg:h-4 transition-transform duration-300 ${
              isHovered && isDropdownVisible ? 'translate-x-1' : ''
            } ${
              isActive ? 'text-white' : 'text-white group-hover:text-white'
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        ) : (
          <svg
            className={`w-3 h-3 lg:w-4 lg:h-4 transition-transform duration-300 ${
              isHovered && isDropdownVisible ? 'rotate-180' : 'rotate-0'
            } ${
              isActive ? 'text-white' : 'text-white group-hover:text-white'
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        )}

        {isActive && (
          <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-navgreen"></div>
        )}
      </Link>

      {/* Dropdown bridge for normal items */}
      {/* {!isCountry && isHovered && isDropdownVisible && (
        <div className="absolute top-full left-0 right-0 h-8 bg-transparent z-45"></div>
      )} */}

      {/* Right side dropdown for country items */}
    
    </div>
  );
};

export default DesktopNavItem;
